const selectNextGame = (_games) => {
    var date = new Date(), currentMSDate = new Date(date).getTime();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var _timeStart = `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}`
    var nextGame = null;

    for (var i = 0; i < _games.length; i++) {
        var realTime = Date.parse(`${_games[i].gameDate} ${_games[i].time_start}`)

        nextGame = (realTime >= currentMSDate ?
            _games[i].cur_minutes && _games[i].cur_minutes.indexOf("הסתיים") > -1 ?
                !nextGame ? realTime : realTime <= nextGame ?
                    realTime : nextGame : nextGame : nextGame);
    }
    // console.log(new Date(nextGame));
}

const LiveBoard = (_data) => {
    var date = new Date(), currentMSDate = new Date(date).getTime();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var month = parseInt(date.getMonth() + 1), month = month < 10 ? "0" + month : month;
    var year = date.getFullYear();
    var nextGame = null, currentGame = null, lastGame = null;
    var _nextGame = null;
    const currentDate = `${month}/15/${year}`;

    for (var i = 0; i < _data.length; i++) {
        var realTime = Date.parse(`${_data[i].gameDate} ${_data[i].time_start}`)
        var realDate = new Date(realTime).getDate();
        var realHour = new Date(realTime).getHours();
        realHour = realHour < 10 ? "0" + realHour : realHour;

        nextGame = (realTime >= currentMSDate ?
            !_data[i].cur_minutes ?
                !nextGame ? realTime : realTime <= nextGame ?
                    realTime : nextGame : nextGame : nextGame);
        if (realTime >= currentMSDate &&
            !_data[i].cur_minutes) {
            if (realTime <= nextGame) {
                _nextGame = _data[i];
            }
        }

        var nextDate = new Date(nextGame).getDate();

        currentGame = (day == realDate &&
        // hours == realHour &&
            currentMSDate >= realTime &&
            (_data[i].cur_minutes && _data[i].cur_minutes.indexOf("הסתיים")) < 0 ?
            _data[i] : currentGame
        )
    }

    return [{
        nextGame: _nextGame,
        currentGame: currentGame,
        lastGame: lastGame
    }];

    // var games = [];
    // for (var i = 0; i < _data.length; i++) {
    //     if (_data[i].gameDate == currentDate) {
    //         games[_data[i].gameDate] = games[_data[i].gameDate] ? games[_data[i].gameDate] : [];
    //         games[_data[i].gameDate].push(_data[i]);
    //     }
    // }
    // selectNextGame(games[currentDate]);
}
const getTimerNextGame = _data => {
    var date = new Date(), currentMSDate = new Date(date).getTime();
    var nextGame = null;

    for (var i = 0; i < _data.length; i++) {
        var realTime = Date.parse(`${_data[i].gameDate} ${_data[i].time_start}`)

        nextGame = (realTime >= currentMSDate ?
            !_data[i].cur_minutes ?
                !nextGame ? realTime : realTime <= nextGame ?
                    realTime : nextGame : nextGame : nextGame);
    }
    return new Date(nextGame);
}

const getFlag = flagFile => {
    if (!flagFile) return;
    return flagFile.split(".")[0];
}
export {
    getTimerNextGame,
    LiveBoard,
    getFlag
}


// WEBPACK FOOTER //
// ./src/Components/NextGame/HandleGames.js